<script setup lang="ts">
	import {cn} from '@/scripts/utils/utils';
	import {ChevronDown} from 'lucide-vue-next';
	import {
		SelectIcon,
		SelectTrigger,
		type SelectTriggerProps,
		useForwardProps,
	} from 'radix-vue';
	import {computed, type HTMLAttributes} from 'vue';

	const props = defineProps<
		SelectTriggerProps & {class?: HTMLAttributes['class']}
	>();

	const delegatedProps = computed(() => {
		const {class: _, ...delegated} = props;

		return delegated;
	});

	const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
	<SelectTrigger
		v-bind="forwardedProps"
		:class="
			cn(
				'border-input bg-background ring-offset-background focus:ring-ring data-placeholder:text-muted-foreground flex h-10 w-full items-center justify-between rounded-md border px-3 py-2 text-start text-sm focus:ring-2 focus:ring-offset-2 focus:outline-hidden disabled:cursor-not-allowed disabled:opacity-50 [&>span]:truncate',
				props.class
			)
		"
	>
		<slot />
		<SelectIcon as-child>
			<ChevronDown class="h-4 w-4 shrink-0 opacity-50" />
		</SelectIcon>
	</SelectTrigger>
</template>
